import { render, staticRenderFns } from "./Payment.vue?vue&type=template&id=fb0fe1fc&scoped=true&"
import script from "./Payment.vue?vue&type=script&lang=ts&"
export * from "./Payment.vue?vue&type=script&lang=ts&"
import style0 from "./Payment.scss?vue&type=style&index=0&id=fb0fe1fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb0fe1fc",
  null
  
)

export default component.exports